import { jarallax, jarallaxElement, jarallaxVideo } from "jarallax";

import Alpine from "alpinejs";

window.Alpine = Alpine;

import MicroModal from "micromodal"; // es6 module

window.MicroModal = MicroModal;

MicroModal.init();

jarallaxVideo();
jarallaxElement();

jarallax(document.querySelectorAll(".jarallax"), {
  speed: 0.2,
});

jarallax(document.querySelectorAll(".jarallax-element"));

Alpine.store("resources", {
  saving_user: false,

  toggleSaving() {
    this.saving_user = !this.saving_user;
  },
});

Alpine.store("conferences", {
  location: "all",
});

Alpine.start();
